import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'EditLinkIcon',
  props: {
    name: {},
    id: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: {name: __props.name, params: {id: __props.id}},
    class: "d-flex material-symbols-outlined edit-icon"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" edit_note ", -1)
    ]))]),
    _: 1
  }, 8, ["to"]))
}
}

})